module.exports = __webpack_public_path__ + "static/media/chatNew.b635344f.svg";